import { render, staticRenderFns } from "./ContentLoaderProfile.vue?vue&type=template&id=490606a0&"
import script from "./ContentLoaderProfile.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports